<micro-lookup domain="chat" obj="chatCarriers" url="/chat/chatCarriers" [key]="chatCarrierId"></micro-lookup>
